import {useCallback, useMemo} from 'react';
import type {ManifestationStatus} from 'api/types';
import {
  metadataEditManifestationStatusChanged,
  metadataEditManifestationStatusPreview,
} from 'services/metadata';
import {useAppDispatch} from 'store/hooks';

export const useHandleManifestationStatus = (
  manifestationId: string,
): {
  handleManifestationStatusPreview: (
    status: ManifestationStatus | undefined,
  ) => void;
  handleManifestationStatusChanged: (status: ManifestationStatus) => void;
} => {
  const dispatch = useAppDispatch();

  const handleManifestationStatusPreview = useCallback(
    (status: ManifestationStatus | undefined) => {
      dispatch(
        metadataEditManifestationStatusPreview({
          id: manifestationId,
          status,
        }),
      );
    },
    [dispatch, manifestationId],
  );

  const handleManifestationStatusChanged = useCallback(
    (
      status: // Status selected in dropdown
      | ManifestationStatus
        // Set to undefined when cancel edits
        | undefined,
    ) => {
      dispatch(
        metadataEditManifestationStatusChanged({
          id: manifestationId,
          status,
        }),
      );
      handleManifestationStatusPreview(undefined);
    },
    [dispatch, handleManifestationStatusPreview, manifestationId],
  );

  return useMemo(() => {
    return {
      handleManifestationStatusPreview,
      handleManifestationStatusChanged,
    };
  }, [handleManifestationStatusPreview, handleManifestationStatusChanged]);
};
